import { render, staticRenderFns } from "./SwitchDebugMode.vue?vue&type=template&id=345d7b08"
import script from "./SwitchDebugMode.vue?vue&type=script&lang=ts"
export * from "./SwitchDebugMode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports